export const ROTULOS_SITUACAO = {
    sem_envio: 'Sem envio',
    pendente_revisao_manual: 'Pendente de revisão manual',
    conforme_automatico: 'Conforme automático',
    conforme_revisado: 'Conforme revisado',
    nao_conforme: 'Não conforme',
};

export const CORES_SITUACAO = {
    sem_envio: '#6c757d',
    pendente_revisao_manual: '#b58900',
    conforme_automatico: '#28a745',
    conforme_revisado: '#28a745',
    nao_conforme: '#dc3545',
};
